import React from "react";
import "../../css/lp-sect-four.css";
import StdImg1 from "../../assets/images/std-img1.png";
import StdImg2 from "../../assets/images/std-img2.png";
import StdImg3 from "../../assets/images/std-img3.png";

const Sect4 = () => {
  return (
    <section id="main-sect-4">
      <div>
        <h2>
          Learn the way you want and how you want
          <span id="sect-4-h2-extra">
            , no distraction, no pressure from anyone
          </span>
        </h2>
        <div className="sect-4-div-1">
          <span>Preview before you start</span>
          <span className="dot">.</span>
          <span>Learn at your own pace</span>
          <span className="dot">.</span>
          <span>Get answers to your questions</span>
        </div>
        <div id="figure-img">
          <figure>
            <div>
              <img src={StdImg1} alt="" />
            </div>
            <figcaption>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
            </figcaption>
          </figure>
          <figure>
            <div>
              <img src={StdImg2} alt="" />
            </div>
            <figcaption>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
            </figcaption>
          </figure>
          <figure>
            <div>
              <img src={StdImg3} alt="" />
            </div>
            <figcaption>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra,
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Sect4;
